<template>
  <div class="sw-grid-flex sw-grid-flex--dir-column">
    <div class="sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center">
      <div
        v-for="input in inputFields"
        :key="'input-'+ input.name"
        class="sw-grid-flex sw-grid-flex--wrap sw-grid-flex__cell-1-1 sw--padding-vert-2 sw-grid-flex--align-center">
        <div class="sw-grid-flex__cell-1-6 sw-grid-flex--align-center">
          <h6>{{input.text}}</h6>
        </div>
        <div class="sw-grid-flex__cell-5-6">
          <input
            type="text"
            class="sw--input-height__medium sw--font-size-14 sw--width-full"
            required
            v-model="input.value">
        </div>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Auto Explode?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="autoExplode" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Generate Parts?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="generateParts" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Supports Color?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="hasColor" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Is PITA?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="isPita" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Material Group</h6>
      </div>
      <div class="sw-grid-flex__cell-1-3 sw--padding-vert-2">
        <input type="text"
               v-if="showAddNewGroup"
               class="sw--input-height__medium sw--font-size-14 sw--width-half left sw--padding-right-2"
               placeholder="Your new group name..."
               v-model="newGroup.name">
        <select v-if="showAddNewGroup"
                v-model="newGroup.parentId"
                class="sw-select--not-round sw--width-half">
          <option :value="0" :selected="newGroup.parentId === 0">-- select a parent --</option>
          <option v-for="group in materialGroups"
                  :selected="newGroup.parentId === group.id"
                  :value="group.id"
                  :key="group.id">
            {{group.name}}
          </option>
        </select>
        <select v-else v-model="materialGroup" class="sw-select--not-round sw--width-full">
          <option :value="0">-- select one --</option>
          <option v-for="group in materialGroups"
                  :value="group.id"
                  :key="group.id">
            {{group.name}}
          </option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2">
        <button v-if="!materialGroup & !showAddNewGroup"
                @click="showAddNewGroup = true"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          New
        </button>
        <button v-if="showAddNewGroup" @click="showAddNewGroup = false"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          Cancel
        </button>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Material Family</h6>
      </div>
      <div class="sw-grid-flex__cell-1-3 sw--padding-vert-2">
        <input type="text"
               v-if="showAddFamily"
               class="sw--input-height__medium sw--font-size-14 sw--width-full"
               placeholder="Your new material family name..."
               v-model="newFamilyName">
        <select v-else v-model="materialFamily" class="sw-select--not-round sw--width-full">
          <option :value="0">-- select one --</option>
          <option v-for="family in materialFamilies"
                  :key="family.id"
                  :value="family.id">
            {{family.name}}
          </option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2">
        <button v-if="!materialFamily & !showAddFamily" @click="showAddFamily = true"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          New
        </button>
        <button v-if="showAddFamily" @click="showAddFamily = false"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          Cancel
        </button>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Material Shopper Family</h6>
      </div>
      <div class="sw-grid-flex__cell-1-3 sw--padding-vert-2">
        <input type="text"
               v-if="showAddShopperFamily"
               class="sw--input-height__medium sw--font-size-14 sw--width-full"
               placeholder="Your new material shopper family name..."
               v-model="newShopperFamilyName">
        <select v-else v-model="materialShopperFamily" class="sw-select--not-round sw--width-full">
          <option :value="0">-- select one --</option>
          <option v-for="family in materialShopperFamilies"
                  :key="family.id"
                  :value="family.id">
            {{family.name}}
          </option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2">
        <button v-if="!materialShopperFamily & !showAddShopperFamily"
                @click="showAddShopperFamily = true"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          New
        </button>
        <button v-if="showAddShopperFamily" @click="showAddShopperFamily = false"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          Cancel
        </button>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>User Group Restricted</h6>
      </div>

      <div class="sw-grid-flex__cell-1-3 sw--padding-vert-2">
        <input type="text"
               v-if="showAddNewUserGroup"
               class="sw--input-height__medium sw--font-size-14 sw--width-full"
               placeholder="Your new user group name..."
               v-model="newUserGroup.name">
        <select v-else v-model="userGroup" class="sw-select--not-round sw--width-full">
          <option :value="0">-- select one --</option>
          <option v-for="group in userGroups"
                  :key="group.id"
                  :value="group.id">
            {{group.name}}
          </option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2">
        <button v-if="!userGroup & !showAddNewUserGroup"
                @click="showAddNewUserGroup = true"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          New
        </button>
        <button v-if="showAddNewUserGroup" @click="showAddNewUserGroup = false"
                class="sw-dms-button sw-dms-button--big sw--cursor-pointer">
          Cancel
        </button>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Owner Restricted?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="ownerRestricted" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
        <h6>Real-time renderable?</h6>
      </div>
      <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
        <select v-model="realMaterialRenderable" class="sw-select--not-round sw--width-half">
          <option :value="0">No</option>
          <option :value="1">Yes</option>
        </select>
      </div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2"></div>
      <div class="sw-grid-flex__cell-1-6 sw--padding-vert-2">
          <h6>Allow Model Fixing?</h6>
      </div>
        <div class="sw-grid-flex__cell-2-3 sw--padding-vert-2">
            <select v-model="isModelFixAllowed" class="sw-select--not-round sw--width-half">
                <option :value="0">No</option>
                <option :value="1">Yes</option>
            </select>
        </div>
      <div class="sw--position-bottom
                sw--position-left
                sw--position-right
                sw--position-fixed
                sw--padding-hor-4
                sw--padding-vert-2
                sw-dms--bg-white
                sw--z-index-10
                sw-grid-flex
                sw--border-grey-64-1
                sw-grid-flex--align-center"
                :class="materialId ? 'sw-grid-flex--justify-flex-end' : 'sw-grid-flex--justify-center'">
        <div v-if="!materialId" class="sw--font-size-14 sw--margin-right-3 sw-grid-flex">
          <span class="sw--text-yellow sw--padding-right-2">Warning:</span> Saving this page will create a new inactive material in the database
        </div>
        <button class="sw-dms-button sw-dms-button--big sw-dms-button--red sw--cursor-pointer" @click="saveBasicInfo">
          {{materialId ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import _ from 'underscore';

    export default {
        name: "material-basic-info",
        mixins: [VueJQueryMixin, VueSwMixin],
        props: {
            materialId: {
                type: Number,
                required: false
            },
            materialGroups: {
                type: Array,
                default: () => ([])
            },
            materialFamilies: {
                type: Array,
                default: () => ([])
            },
            materialShopperFamilies: {
                type: Array,
                default: () => ([])
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            },
            userGroups: {
              type: Array,
              default: () => ([])
            },
        },
        data: () => ({
            inputFields: [
                {name: 'materialTitle', text: 'Title', value: ''},
                {name: 'abbreviation', text: 'Abbreviation', value: ''},
                {name: 'description', text: 'Description', value: ''},
                {name: 'shopperDescription', text: 'Shopper Description', value: ''},
                {name: 'thumbPath', text: 'Thumbnail Path', value: ''},
                {name: 'materialDetailLink', text: 'Material Guide Link', value: '/materials/'},
                {name: 'density', text: 'Density', value: 0}
            ],
            autoExplode: 0,
            generateParts: 0,
            hasColor: 0,
            isPita: 0,
            userGroup: 0,
            materialGroup: 0,
            materialFamily: 0,
            materialShopperFamily: 0,
            showAddNewUserGroup: false,
            newUserGroup: { parentId: 318, name: '' },
            showAddNewGroup: false,
            newGroup: { parentId: 0, name: ''},
            newFamilyName: '',
            newShopperFamilyName: '',
            showAddFamily: false,
            showAddShopperFamily: false,
            ownerRestricted: 0,
            realMaterialRenderable: 0,
            isModelFixAllowed: 0

        }),
        created() {
          if (this.currentMaterial && !_.isEmpty(this.currentMaterial)) {
              this.inputFields[0].value = this.currentMaterial.basicInfo.title;
              this.inputFields[1].value = this.currentMaterial.basicInfo.abbreviation;
              this.inputFields[2].value = this.currentMaterial.basicInfo.description;
              this.inputFields[3].value = this.currentMaterial.basicInfo.shopperDescription;
              this.inputFields[4].value = this.currentMaterial.basicInfo.thumbSwatch;
              this.inputFields[5].value = this.currentMaterial.basicInfo.materialGuidelinesUrl;
              this.inputFields[6].value = this.currentMaterial.basicInfo.density;
              this.autoExplode = this.currentMaterial.basicInfo.autoExplode;
              this.generateParts = this.currentMaterial.basicInfo.generateParts;
              this.isPita = this.currentMaterial.basicInfo.isPita;
              this.hasColor = this.currentMaterial.basicInfo.supportsColor;
              this.materialFamily = this.currentMaterial.materialFamilyId;
              this.materialGroup = this.currentMaterial.materialGroupId;
              this.materialShopperFamily = this.currentMaterial.materialShopperFamilyId;
              this.ownerRestricted = this.currentMaterial.isOwnerRestricted;
              this.userGroup = this.currentMaterial.userGroupId;
              this.realMaterialRenderable = this.currentMaterial.basicInfo.realMaterialRenderable;
              this.isModelFixAllowed = this.currentMaterial.basicInfo.isModelFixAllowed;
          }
        },
        methods: {
            dataToObj() {
                let data = {};
                this.inputFields.forEach(field => {
                    data[field.name] = field.value;
                })
                data.autoExplode = this.autoExplode;
                data.generateParts = this.generateParts;
                data.isPita = this.isPita;
                data.hasColor = this.hasColor;
                data.materialGroupId = this.materialGroup;
                data.materialFamilyId = this.materialFamily;
                data.materialShopperFamilyId = this.materialShopperFamily;
                data.userGroupId = this.userGroup
                data.realMaterialRenderable = this.realMaterialRenderable;
                data.isModelFixAllowed = this.isModelFixAllowed;
                if (this.ownerRestricted !== 0) data.ownerRestricted = this.ownerRestricted;
                if (this.showAddNewGroup) data.newGroup = this.newGroup;
                if (this.showAddFamily) data.newFamilyName = this.newFamilyName;
                if (this.showAddShopperFamily) data.newShopperFamilyName = this.newShopperFamilyName;
                if (this.showAddNewUserGroup) data.newUserGroup = this.newUserGroup;
                if (this.materialId) data.materialId = this.materialId;
                return data;
            },
            saveBasicInfo() {
                let _this = this;
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/basic-info',
                    dataType: 'json',
                    data: _this.dataToObj(),
                    success: (data) => {
                        _this.$emit('success', data);
                        this.$sw.notifications.success('Saved!')
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });

            }
        }
    }
</script>
